import React, { Component, Fragment } from "react";
import axios from "../../../containers/api";
import {Row, Card, CardBody, CardTitle, Button, Modal, ModalHeader, ModalBody} from "reactstrap";
import { Colxx} from "../../../components/common/CustomBootstrap";
import {Table} from "../../../components/table/Table";
import {showCatchError, toCurrency} from "../../../helpers/Utils";
import PersonAccountActivities from "../../../components/admin/PersonAccountActivities";
import ChangePassDriver from "../../../components/admin/ChangePassDriver";

export default class InActive extends Component {
    constructor(props) {
        super(props);

        this.state = {
            ChangePassModal: false,
            ShowAccountActivityModal: false,
            Drivers: [],
            oneDriver: {},
            DriverId: null,
        };
    }

    componentDidMount() {
        this.CheckMemberTypeIsAdmin();
    }

    CheckMemberTypeIsAdmin = () => {
        this.props.showSpinner();
        axios.get('/api/v1/users/GetAccessIsAdmin')
            .then((res) => {
                this.props.hideSpinner();
                if (res.data) {
                    this.GetDrivers();
                } else {
                    this.props.history.push('/error404')
                }
            })
            .catch((error) => {
                this.props.hideSpinner();
                console.log(error.response);
                this.props.showAlert(showCatchError(error), "error");
            });
    };

    GetDrivers = () => {
        this.props.showSpinner();
        axios.get('api/v1/drivers/GetDeactiveDriver')
            .then((res) => {
                this.props.hideSpinner();
                this.setState({Drivers: res.data.data});
            })
            .catch((error) => {
                this.props.hideSpinner();
                console.log(error.response);
                this.props.showAlert(showCatchError(error), "error");
            });
    };

    LogOutDriver = (id) => {
        this.props.closeSweetAlert();
        this.props.showSpinner();
        axios.get('api/DriverApi/LogOutDriver?id=' + id)
            .then(() => {
                this.props.showAlert("راننده با موفقیت از سیستم خارج شد", 'success');
                this.GetDrivers();
            })
            .catch((error) => {
                this.props.hideSpinner();
                this.props.showAlert(showCatchError(error), "error");
                console.log(error.response);
            });
    };

    Active = (id) => {
        this.props.closeSweetAlert();
        this.props.showSpinner();
        axios.post('api/v1/drivers/ActiveDriver?driverId=' + id, null)
            .then(() => {
                this.props.showAlert("راننده با موفقیت فعال شد", 'success');
                this.GetDrivers();
            })
            .catch((error) => {
                this.props.hideSpinner();
                this.props.showAlert(showCatchError(error), "error");
                console.log(error.response);
            });
    };

    closeModal = (modalName) => {
        this.setState({ [modalName]: false });
    };

    render() {
        return (
            <Fragment>
                <Row>
                    <Colxx xxs="12" className="mb-4">
                        <Card>
                            <CardBody>
                                <CardTitle>مدیریت رانندگان غیر فعال</CardTitle>

                                <Table
                                    tableHeaders={[
                                        "شناسه",
                                        "نام کامل",
                                        "کد ملی",
                                        "موبایل",
                                        "هوشمند راننده",
                                        "تاریخ",
                                        "ساعت",
                                        "وضعیت"
                                    ]}

                                    tableRow={this.state.Drivers}

                                    tableData={[
                                        x => {
                                            return x.id
                                        },
                                        x => {
                                            return x.name + " " + x.family
                                        },
                                        x => {
                                            return x.nationalId
                                        },
                                        x => {
                                            return x.mobile
                                        },
                                        x => {
                                            return x.cardNumber
                                        },
                                        x => {
                                            return x.registerDate;
                                        },
                                        x => {
                                            return x.registerTime;
                                        },
                                        x => {
                                            if (x.driverActive === false) {
                                                return (
                                                    <Button outline color="success" size="sm"
                                                            onClick={() => this.props.showSweetAlert("آیا این راننده فعال شود؟", "", "success", () => this.Active(x.id))}>
                                                        فعال کردن
                                                    </Button>
                                                )
                                            }
                                        }
                                    ]}
                                />
                            </CardBody>
                        </Card>
                    </Colxx>
                </Row>

                <Modal isOpen={this.state.ShowAccountActivityModal} toggle={() => this.closeModal("ShowAccountActivityModal")} size="xlg">
                    <ModalHeader toggle={() => this.closeModal("ShowAccountActivityModal")}>
                        لیست تراکنش‌های کیف پول
                    </ModalHeader>
                    <ModalBody>
                        <PersonAccountActivities
                            id={this.state.DriverId}
                            showSpinner={this.props.showSpinner}
                            hideSpinner={this.props.hideSpinner}
                            showAlert={this.props.showAlert}
                        />
                    </ModalBody>
                </Modal>

                <Modal isOpen={this.state.ChangePassModal} toggle={() => this.closeModal("ChangePassModal")} size="xlg">
                    <ModalHeader toggle={() => this.closeModal("ChangePassModal")}>
                        تغییر رمز عبور راننده
                    </ModalHeader>
                    <ModalBody>
                        <ChangePassDriver
                            driver={this.state.oneDriver}
                            showSpinner={this.props.showSpinner}
                            hideSpinner={this.props.hideSpinner}
                            showAlert={this.props.showAlert}
                            showSweetAlert={this.props.showSweetAlert}
                            closeSweetAlert={this.props.closeSweetAlert}
                        />
                    </ModalBody>
                </Modal>
            </Fragment>
        )
    }
}
